export default "__VITE_ASSET__ClsGFLh3__"